import React, { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import css from '@styled-system/css'
import styled from 'styled-components'
import { H3, Tag, LightTheme, P, Box, HR } from 'ui/bend'
import Carousel from '../common/components/Carousel/Carousel'
import { ItemCards } from './ItemCards'
import { UserProvider } from 'context'
import { axios } from 'api'
import ProgramButtonActions from 'components_v1/programs/ProgramButtonActions'

const Main = styled(Box)`
  .no-tag {
    padding-top: 26px;
  }
  .no-item-tags .card-item {
    padding-top: 0;
  }
`

const H3Title = styled(H3)(() =>
  css({
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Arquitecta',
    fontSize: '32px',
    fontWeight: '950',
    letterSpacing: '2.24px',
    textTransform: 'uppercase'
  })
)

const ItemTitle = styled(Tag)`
  font-size: 18px;
  font-weight: 950;
  line-height: 24px;
  letter-spacing: 1.44px;
`

const ItemDesc = styled(P)`
  color: #000;
  line-height: 24px;
  letter-spacing: 0.352px;
`

const WidgetOuter = styled.div`
  flex-direction: column;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: 16px !important;

  p {
    margin: 0;
  }
  .carousels {
    margin-top: 12px;
  }

  .main-flex {
    max-width: 716px;
    margin: 0 4%;
    @media screen and (min-width: 768px) {
      margin: 0;
    }

    @media screen and (min-width: 712px) {
      max-width: none;
    }
  }
`

const SeriesStructureSchemaRender = ({ planId, user }) => {
  const [schema, setSchema] = useState(null)

  const fetchData = async () => {
    try {
      const res = await axios.get(`/plan_entries?plan_id=${planId}`)
      if (res.status === 200) {
        setSchema(res?.data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!schema) {
    return null
  }

  const [slidesOffsetBefore, slidesOffsetAfter] = [0, 0]

  return (
    <UserProvider user={user}>
      <WidgetOuter className='section-container'>
        <Main className='main-flex'>
          <ThemeProvider theme={LightTheme}>
            <ProgramButtonActions fetchData={fetchData} />
            <H3Title id='workouts-section'>Classes</H3Title>
            {schema.sections.map((section, index) => {
              const hasItemTag = section?.items?.some((obj) =>
                Boolean(obj.itemTag)
              )
              return (
                <div key={index} className={hasItemTag ? '' : 'no-item-tags'}>
                  <ItemTitle>{section.title}</ItemTitle>
                  <ItemDesc>{section.description}</ItemDesc>
                  <div className='carousels'>
                    <Carousel
                      card={ItemCards}
                      mx={['16px', '16px', '16px', '0px']}
                      data={section.items}
                      isStructuredSeriesCarousel={true}
                      breakpoints={{
                        0: {
                          slidesOffsetBefore,
                          slidesOffsetAfter
                        },
                        320: {
                          slidesPerView: 1.45,
                          slidesOffsetBefore,
                          slidesOffsetAfter
                        },
                        525: {
                          slidesPerView: 2,
                          slidesOffsetBefore,
                          slidesOffsetAfter
                        },
                        768: {
                          slidesPerView: 2.5,
                          spaceBetween: 20,
                          slidesOffsetBefore,
                          slidesOffsetAfter
                        },
                        900: {
                          slidesPerView: 3,
                          spaceBetween: 20,
                          slidesOffsetBefore: 0,
                          slidesOffsetAfter: 0
                        }
                      }}
                    />
                  </div>
                  {index != schema.sections.length - 1 && (
                    <HR mb={'32px'} mt={'24px'} />
                  )}
                </div>
              )
            })}
          </ThemeProvider>
        </Main>
      </WidgetOuter>
    </UserProvider>
  )
}

export default SeriesStructureSchemaRender
